// Copyright (c) Move Closer 2022.

import { ValidationRules } from '../../../shared/molecules/Form'

/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export const ValidatorsMap: ValidationRules = {
  dateOfBirth: 'filled|string',
  firstName: 'required|string|min:3',
  lastName: 'required|string|min:2'
}
